<template>
  <div class="shareholder">
    <h4>
      <span class="red">*</span>
      <span>信用限额审批规则</span>
    </h4>
    <div>
      <a-table
        :columns="columns"
        :data-source="data"
        bordered
        :pagination="false"
      >
        <template slot="interval" slot-scope="text, record, key">
          <div :key="key">
            <div style="width:100%;">
              <a-input
                style=" width: 160px; text-align: center"
                :value="record.min"
                allowClear
                @change="e => changeInterval(e.target.value, key, 'min')"
              />
              ~
              <a-input
                style="width: 160px; text-align: center; "
                placeholder=""
                allowClear
                :value="record.max"
                @change="e => changeInterval(e.target.value, key, 'max')"
              />
            </div>
            <div style="width:100%;margin-top:10px;">
              <a-checkbox
                allowClear
                style="width:160px;text-align:center;"
                :value="record.minEqual"
                :checked="number2Boolean(record.minEqual)"
                @change="
                  value => {
                    changeInterval(value, key, 'minEqual')
                  }
                "
              >
                包含
              </a-checkbox>
              <a-checkbox
                style="width:160px;text-align:center;"
                :value="record.maxEqual"
                :checked="number2Boolean(record.maxEqual)"
                @change="
                  value => {
                    changeInterval(value, key, 'maxEqual')
                  }
                "
              >
                包含
              </a-checkbox>
            </div>
          </div>
        </template>
        <template slot="creditLevel" slot-scope="text, record, key">
          <div :key="key">
            <a-select
              style="margin: -5px 0"
              placeholder="请选择审批级别"
              :value="record.creditLevel"
              @change="
                value => {
                  changeInterval(value, key, 'creditLevel')
                }
              "
            >
              <a-select-option
                v-for="item in applyList"
                :value="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record, key">
          <div class="editable-row-operations">
            <!--delete-->
            <a-popconfirm title="确定要删除吗?" @confirm="() => onDelete(key)">
              <a href="javascript:void(0)">
                删除规则
              </a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>
      <div class="margin-top-20">
        <a-button class="width-100" icon="plus" type="dashed" @click="add">
          新增规则
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixinContact'
//import cloneDeep from 'lodash/cloneDeep'
//import { columns } from '../../../client/client-center/detail/credit-rating/schema'
import { getRules } from 'views/setting/api'
export default {
  mixins: [mixin],
  name: 'create-form',
  props: ['id', 'isExtra'],
  data() {
    return {
      formLayout: 'vertical',
      companyCode: '',
      data: [
        {
          key: 0,
          id: '',
          min: '',
          max: '',
          maxEqual: 0,
          minEqual: 0,
          creditLevel: '',
        },
      ],
      editingKey: '',
      count: 0,
      cacheData: [],
      applyList: [
        {
          label: '信用一级',
          value: 1,
        },
        {
          label: '信用二级',
          value: 2,
        },
        {
          label: '信用三级',
          value: 3,
        },
        {
          label: '信用四级',
          value: 4,
        },
        {
          label: '信用五级',
          value: 5,
        },
      ],
    }
  },

  created() {},
  methods: {
    async query() {
      const { data } = await getRules(this.id)
      this.data = [...data.modelRules]
      this.data.map((item, key) => {
        if (!item.key) {
          item['key'] = key
        }
      })
      this.$emit('getData', this.data)
    },
    changeInterval(value, key, column) {
      var newData = [...this.data]
      const target = newData.filter(item => key == item.key)[0]
      if (target) {
        if (column == 'minEqual' || column == 'maxEqual') {
          if (value.target.checked) {
            target[column] = 1
          } else {
            target[column] = 0
          }
        } else {
          target[column] = value
        }
        this.data = newData
      }

      this.$emit('getData', this.data)
    },
    add() {
      this.count = this.data.length
      if (this.count == 10) {
        this.$message.warning('最多可以添加10个规则！')
        return false
      } else {
        const addData = {
          key: this.count,
          id: '',
          min: '',
          max: '',
          maxEqual: 0,
          minEqual: 0,
          creditLevel: '',
        }
        this.data = [...this.data, addData]
      }
    },
    number2Boolean(num) {
      if (num == 1) {
        return true
      } else {
        return false
      }
    },
    onDelete(key) {
      let afterDelData = this.data.filter(item => {
        return item.key != key
      })
      this.data = afterDelData
      this.data.map((item, index) => {
        return (item.key = index)
      })
      this.$emit('getData', this.data)
    },
  },
}
</script>
<style lang="less" scoped>
.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
.red {
  color: #f00;
}
</style>
